'use client';

import React from 'react';

import AppErrorTitle from '../AppErrorTitle';
import styles from '../AppError.module.css';

const AppErrorTxNotFound = () => {
  return (
    <>
      <AppErrorTitle title="Sorry, we are unable to locate this transaction hash"/>
      <ol className={ styles.orderedList }>
        <li>
          If you have just submitted this transaction please wait for at least 30 seconds before refreshing this page.
        </li>
        <li>
          It could still be in the TX Pool of a different node, waiting to be broadcasted.
        </li>
        <li>
          During times when the network is busy (i.e during ICOs) it can take a while for your transaction to propagate through the network and for us to index it.
        </li>
        <li>
          <span>If it still does not show up after 1 hour, please check with your </span>
          <span className={ styles.bold }>sender/exchange/wallet/transaction provider</span>
          <span> for additional information.</span>
        </li>
      </ol>
      <a href="/" className={ styles.backButton }>
        Back to home
      </a>
    </>
  );
};

export default AppErrorTxNotFound;
